<template>
  <div class="sidebar-container">
    <BreadcrumbsContainer :entity-type="entityType" />
    <TreeFilterContainer
      :entity-type="entityType"
      class="category-filters-container"
    />
    <FilterCardsContainer
      :brands="brands"
      :filter-types="filterTypes"
      :other-filters="otherFilters"
    />
    <ScrollToTopButton :filter-types="filterTypes" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BreadcrumbsContainer from './BreadcrumbsContainer.vue'
import FilterCardsContainer from './FilterCardsContainer.vue'
import TreeFilterContainer from './TreeFilterContainer.vue'
import ScrollToTopButton from './ScrollToTopButton.vue'

export default {
  name: 'SidebarContainer',
  components: {
    BreadcrumbsContainer,
    FilterCardsContainer,
    TreeFilterContainer,
    ScrollToTopButton
  },
  props: {
    entityType: {
      type: String,
      required: true
    },
    /**
     * This is defined in the route. Prefixed with 'param' to not get confused
     */
    paramTopCategory: {
      type: String,
      required: true
    },
    /**
     * This is defined in the route. Prefixed with 'param' to not get confused
     */
    paramCategory: {
      type: String,
      required: true
    },
    /**
     * This is defined in the route. Prefixed with 'param' to not get confused
     */
    paramSubCategory: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      brands: 'listingPageFilters/brandFilters',
      otherFilters: 'listingPageFilters/otherFilters',
      filterTypes: 'listingPageFilters/typeFilters'
    })
  }
}
</script>
